import compare from "@/pages/company/compare/@redux/slice";
import elements from "@/pages/elements/@redux/slice";
import user_dashboard from "@/pages/user/dashboard/@redux/slice";
import user_company from "@/pages/user/dashboard/pages/seller/listing/module/company/@redux/slice";
import user_products from "@/pages/user/dashboard/pages/seller/listing/module/products/@redux/slice";
import user_services from "@/pages/user/dashboard/pages/seller/listing/module/services/@redux/slice";
import user_portfolio from "@/pages/user/dashboard/pages/seller/listing/module/portfolio/@redux/slice";
import user_buyer_business from "@/pages/user/dashboard/pages/buyer/bussiness/@redux/slice";
import user_buyer_rfqdetails from "@/pages/user/dashboard/pages/buyer/manage/@redux/slice"
export const allReducers = {
  compare,
  elements,
  user_dashboard,
  user_company,
  user_portfolio,
  user_products,
  user_services,
  user_buyer_business,
  user_buyer_rfqdetails
};
